export default __webpack_public_path__ + "static/media/logo.2f3362bd.svg";